import React, { useEffect, useState, useRef } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Avatar, Badge, Popconfirm, Switch } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useLocation } from "react-router-dom";

import SelectSource from "./modals/select-source";
import SelectRebalanceProfile from "./modals/select-rebalance-profile";
import AddAlert from "./modals/add-alert";
import CreateConversion from "./modals/create-conversion";

import noStrategy from '../common/img/noStrategy.png'
import sources from "../common/sources";
import updateBot from "../common/helpers/update-bot";
import fetchProfiles from '../common/helpers/fetch-profiles';
import fetchBots from "../common/helpers/fetch-bots";
import createProfile from "../common/helpers/create-profile";
import createOrders from '../common/helpers/create-orders';
import Triangular from './triangular';
import createTriangulars from '../common/helpers/create-triangulars';
import createAccumulators from "../common/helpers/create-accumulators";
import deleteAccumulators from "../common/helpers/delete-accumulator";
import editAccumulators from "../common/helpers/edit-accumulator";
import cancelOrder from '../common/helpers/cancel-order';
import fetchScript from "../common/helpers/fetch-script";
import { useAppContext, APP_ACTIONS, WS, userId } from "../../context/appContext";
import { CaretRightOutlined, PauseOutlined, SearchOutlined, MoreOutlined } from '@ant-design/icons';
import moment from "moment";
import cancelOrderAndUpdate from "../common/helpers/cancel-order-and-update";
import Balance from "../Balance/balance";
import History from "../History/history";
import Status from "../Status/status";
import EdgeCaseViewer from "../EdgeCaseViewer/edge-case-viewer";
import fetchMarkets from "../common/helpers/fetch-profile-markets";
import TableRow from "./tableRow";
import TableRowAccumulate from "./tableRowAccumulate";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import createUnprocessedOrder from "../common/helpers/create-unprocessed-order";
import AdvancedFilter from "./modals/advanced-filter";
import BulkUpdate from "./modals/bulk-update";

const { Option } = Select;
const { TabPane } = Tabs;

const tableHeaderStyle = { fontSize: '0.85em', borderTop: "1px solid #cccccc", borderBottom: "1px solid #666666", color: "#a3a3a3", textAlign: "left" }
const tableSubHeaderStyle = { fontSize: '0.8em', borderBottom: "1px solid #cccccc", color: "#cccccc", textAlign: "left" }
const tableRowStyle = { fontSize: 16, borderTop: "1px solid #666666", color: "white", backgroundImage: "linear-gradient(180deg, #535353 0%, #161616 25%)", textAlign: "left" }
const tableSubRowStyle = { fontSize: 16, borderBottom: "1px solid #cccccc", color: "white", textAlign: "left" }
const tableRowEditStyle = { borderBottom: "1px solid #cccccc", paddingRight: 10, paddingTop: 10, paddingBottom: 10 }
const key = 'order_place';

const Advanced = ({ selectedBot, orders, serverUnresponsive, setOrders, disableAction, setDisableAction, setDisplayAdvancedSection, setBotStates, accumulators, setAccumulators }) => {
    const {
        state: { strategies, user, bots, exchangeMarkets, logsSuccess, logsError },
        dispatch,
    } = useAppContext();

    const botStatus = strategies?.find(strategy => strategy.id === selectedBot.id)?.botState || 'stop';
    const firstRender = useRef(true);
    // const selectedBot = location.state;
    const [displaySelectSource, setDisplaySelectSource] = useState(false);
    const [displayRebalanceProfile, setDisplayRebalanceProfile] = useState(false);
    const [displayCreateConversion, setDisplayCreateConversion] = useState(false);
    const [displayBulkUpdate, setDisplayBulkUpdate] = useState(false);
    const [displayAddAlert, setDisplayAddAlert] = useState(false);
    const [displayWarning, setDisplayWarning] = useState(false);
    const [displayBalanceSection, setDisplayBalanceSection] = useState(false);
    const [displayHistorySection, setDisplayHistorySection] = useState(false);
    const [displayStatusSection, setDisplayStatusSection] = useState(false);
    const [displayCaseViewerSection, setDisplayCaseViewerSection] = useState(false);
    const [warningType, setWarningType] = useState();
    const [botState, setBotState] = useState(strategies?.find(strategy => strategy.id === selectedBot.id)?.botState || 'stop');
    const [markets, setMarkets] = useState([]);
    const [customScripts, setCustomScripts] = useState([]);
    const [filter, setFilter] = useState();
    // const [serverUnresponsive, setServerUnresponsive] = useState(false);
    const [exit, setExist] = useState(false);

    // const [orders, setOrders] = useState([]);
    const defaultOrderItem = {
        id: null,
        symbol: null,
        side: null,
        minimum_size: null,
        maximum_size: null,
        spread: null,
        sensitivity: null,
        timer: null,
        bot_id: selectedBot.id,
        user_id: userId,
        rebalance: null,
        source: null,
        source_symbol: null,
        rebalance_symbol: null,
        conversion: null,
        order_status: null,
        balance_limit: null,
        cooldown_period: 3,
        logs: [],
        expanded: false,
        saved: false,
        paused: false
    }
    const [orderItem, setOrderItem] = useState(defaultOrderItem);
    const [newOrderCreate, setNewOrderCreate] = useState(false);
    // const [disableAction, setDisableAction] = useState(false);
    const [displayAdvancedConfig, setDisplayAdvancedConfig] = useState(false);

    const [newAccumulatorCreate, setNewAccumulatorCreate] = useState(false);

    const defaultAccumulatorItem = {
        id: null,
        symbol: null,
        interval: null,
        saved: false,
        paused: false,
        bot_id: selectedBot.id,
        user_id: userId,
        logs: [],
        expanded: false,
    }
    const [accumulatorItem, setAccumulatorItem] = useState(defaultAccumulatorItem);
    const [successLogs, setSuccessLogs] = useState([]);
    const [successMinLogs, setSuccessMinLogs] = useState([]);
    const [errorLogs, setErrorLogs] = useState([]);
    const [errorMinLogs, setErrorMinLogs] = useState([]);
    const [displayLogs, setDisplayLogs] = useState(false);
    const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
    const [filters, setFilters] = useState([
        { field: 'symbol', type: 'string', label: 'Symbol', value: null }
    ]);
    const [enableFilters, setEnableFilters] = useState(false);
    useEffect(() => {
        const data = strategies.find(strategy => strategy.id === selectedBot.id)
        // const data = JSON.parse(localStorage.getItem(`${selectedBot.id}_strategies`))

        if (data) {
            setBotState(data.botState)
        }


        setOrders(previousState => {
            let newOrders = [...previousState]
            newOrders = newOrders.filter(order => order.saved);
            return newOrders;
        })

    }, [])

    useEffect(() => {
        const _filters = JSON.parse(localStorage.getItem(`filters`))
        if (_filters) {
            setFilters(_filters)
        }
    }, [])

    useEffect(() => {
        setBotStates(previousState => {
            const newState = Object.assign({}, previousState)
            newState[selectedBot.id] = botState;
            return newState;
        })
        if (firstRender.current) {
            firstRender.current = false;
        } else {
            dispatch({
                type: APP_ACTIONS.SET_BOT_STRATEGIES,
                payload: { id: selectedBot.id, botState },
            })

            // localStorage.setItem(`${selectedBot.id}_strategies`, JSON.stringify({ id: selectedBot.id, botState }));
        };

    }, [botState])

    useEffect(() => {
        setBotState(botStatus)
    }, [botStatus])

    useEffect(() => {
        if (selectedBot.active) {
            setBotState('play');
        }

        const selectedMarket = exchangeMarkets.find(x => x.id == `${selectedBot.host.exchange}${selectedBot.host.is_sandbox}`);

        if (selectedMarket && selectedMarket.date.getTime() + 1000 * 60 * 120 > new Date().getTime()) {
            setMarkets(selectedMarket.markets);
        }
        else {
            fetchMarkets(selectedBot.host.id).then((res) => {
                setMarkets(res);
                dispatch({
                    type: APP_ACTIONS.SET_MARKETS,
                    payload: { id: `${selectedBot.host.exchange}${selectedBot.host.is_sandbox}`, markets: res, date: new Date() }
                })
            })
        }

        fetchScript().then(res => {
            if (Array.isArray(res)) {
                setCustomScripts([...res])
            }
        })
    }, [])

    useEffect(() => {
        const logs = logsSuccess?.filter(log => log?.bot_id === selectedBot?.id).map(x => x?.log);
        setSuccessLogs(logs);
        setSuccessMinLogs(logs.slice(0, 4))
    }, [logsSuccess])

    useEffect(() => {
        const logs = logsError?.filter(log => log?.bot_id === selectedBot?.id).map(x => x?.log);
        setErrorLogs(logs);
        setErrorMinLogs(logs.slice(0, 4))
    }, [logsError])


    const handleDrop = (droppedItem) => {
        if (!droppedItem.destination) return;
        var updatedList = [...orders.filter(order => order?.bot_id === selectedBot.id)];
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        orders = orders.filter(order => order?.bot_id !== selectedBot.id)
        orders = [...orders, ...updatedList]
        setOrders(orders);
    };


    const createOrder = () => {
        setNewOrderCreate(true);
        setOrders([...orders, orderItem])

    }
    const cancelCreateOrder = () => {
        const newOrders = [...orders];
        if (!orderItem.id) {
            newOrders.pop();

        } else {
            newOrders.filter(order => order?.bot_id === selectedBot.id).forEach(x => {
                x.saved = true;
            })
            setOrderItem(defaultOrderItem);
        }

        setOrders(newOrders);
        setNewOrderCreate(false);
    }
    const sendUnprocessOrder = (order, method, originalId = null) => {
        const unprocessedOrder = JSON.parse(JSON.stringify(order));
        delete unprocessedOrder.logs;
        delete unprocessedOrder.expanded;
        delete unprocessedOrder.saved;
        if (originalId) {
            unprocessedOrder.originalId = originalId;
        }
        createUnprocessedOrder({ method, order: unprocessedOrder }).then((res) => {
            // console.log({ res })
        }).catch((err) => {
            // console.log({ err })
        })
    }
    const addOrder = (orderItemId = null) => {
        if (!user.is_admin) {
            if (orders.filter(order => order?.bot_id === selectedBot.id).length - 1 >= user.strategy_limit) {
                message.error(`strategy creation limit reached`);
                return;
            }
        }
        if (!orderItem.symbol) {
            message.error('Please enter symbol');
            return;
        }
        if (orderItem.side == null) {
            message.error('Please select side');
            return;
        }
        if (!orderItem.minimum_size || isNaN(parseFloat(orderItem.minimum_size))) {
            message.error('Please enter minimum size');
            return;
        }
        if (!orderItem.maximum_size || isNaN(parseFloat(orderItem.maximum_size))) {
            message.error('Please enter maximum size');
            return;
        }
        if (parseFloat(orderItem.maximum_size) < parseFloat(orderItem.minimum_size)) {
            message.error('maximum size cannot be lower than minimum size');
            return;
        }
        // if (!orderItem.rebalance) {
        //     message.error('Please select rebalance profile');
        //     return;
        // }
        // if (!orderItem.rebalance_symbol) {
        //     message.error('Please enter rebalance symbol');
        //     return;
        // }
        if (!orderItem.source) {
            message.error('Please select source');
            return;
        }
        if (!orderItem.source_symbol) {
            message.error('Please enter source symbol');
            return;
        }

        if (orderItem.spread == null || isNaN(parseFloat(orderItem.spread))) {
            message.error('Please enter spread');
            return;
        }
        if (!orderItem.timer || isNaN(parseInt(orderItem.timer))) {
            message.error('Please enter timer');
            return;
        }

        if (parseInt(orderItem.timer) < 5) {
            message.error('timer needs to be minimum 5 seconds');
            return;
        }

        let newOrderItem = Object.assign({}, orderItem);
        // if (!orderItem.sensitivity) {
        //     newOrderItem.sensitivity = parseFloat(orderItem.spread) / 2
        // }
        console.log({
            newOrderItem
        })
        if (!newOrderItem.id) newOrderItem.id = uuidv4();

        newOrderItem.sensitivity = parseFloat(newOrderItem.sensitivity)
        if (isNaN(newOrderItem.sensitivity)) { newOrderItem.sensitivity = null }

        newOrderItem.cooldown_period = parseFloat(newOrderItem.cooldown_period)
        if (isNaN(newOrderItem.cooldown_period)) { newOrderItem.cooldown_period = null }

        newOrderItem.spread = parseFloat(newOrderItem.spread)
        newOrderItem.timer = parseFloat(newOrderItem.timer)

        newOrderItem.bot_id = selectedBot.id;
        newOrderItem.minimum_size = parseFloat(newOrderItem.minimum_size);
        newOrderItem.maximum_size = parseFloat(newOrderItem.maximum_size);

        console.log({
            newOrderItem
        })

        let newOrders = [...orders];
        let Index;
        if (orderItemId) {
            Index = newOrders.findIndex(order => !order.saved && order.id == orderItemId);
        } else {
            Index = newOrders.findIndex(order => !order.saved);
        }

        newOrders[Index] = newOrderItem;
        newOrders[Index].saved = true;

        setOrders(newOrders);
        setNewOrderCreate(false);
        console.log({ orders })

        if (orderItemId) {
            // sendUnprocessOrder(newOrders[Index], 'edit');
        } else {
            // sendUnprocessOrder(newOrders[Index], 'add');
        }

        setOrderItem({
            symbol: null,
            side: null,
            minimum_size: null,
            maximum_size: null,
            spread: null,
            sensitivity: null,
            timer: null,
            bot_id: selectedBot.id,
            user_id: userId,
            rebalance: null,
            source: null,
            source_symbol: null,
            rebalance_symbol: null,
            conversion: null,
            order_status: null,
            balance_limit: null,
            logs: [],
            expanded: false,
            saved: false,
            paused: false
        })

        if (botState === 'play') {
            // setDisableAction(true);
            let noOpenOrder = true;
            newOrders[Index]?.logs?.forEach(log => {
                if (log.order_status === 'open') {
                    noOpenOrder = false;
                    const clone = Object.assign({}, newOrders[Index]);
                    delete clone.logs;
                    cancelOrderAndUpdate(log.id, clone).then(res => {
                        if (res.error) {
                            message.error(res.error)
                        }

                        setOrders(previousState => {
                            let newOrders = [...previousState]
                            newOrders.forEach(order => {
                                if (order.id === res.id) {
                                    order.logs.forEach(log => {
                                        if (log.id === res.id && log.order_id === res.order_key) {
                                            log.order_status = 'canceled';
                                        }
                                    })
                                }
                            })
                            return newOrders;
                        })
                        // setDisableAction(false);
                        message.destroy('cancel');
                        console.log(res);
                    }).catch(err => {
                        // setDisableAction(false);
                    })
                    console.log({ log })
                }

            })
            if (noOpenOrder) {
                const logLength = newOrders[Index]?.logs?.length;
                const lastLog = Object.assign({}, newOrders[Index]?.logs?.[logLength - 1]);
                const clone = Object.assign({}, newOrders[Index]);
                delete clone.logs;
                if (lastLog?.order_status === 'closed' || lastLog?.order_status === 'filled') {
                    clone.order_status = 'closed';
                    cancelOrderAndUpdate(lastLog.id, clone)
                } else {
                    createOrders([clone])
                }
            }
        }
    }

    const createRandomOrder = () => {

        function get_random(list) {
            return list[Math.floor((Math.random() * list.length))];
        }
        function randomFromInterval(min, max) { // min and max included 
            return Math.random() * (max - min) + min
        }
        let randomOrder = [
            {
                id: uuidv4(),
                symbol: get_random(["BTC/USDT"]),
                // sensitivity: randomFromInterval(0.1, 0.5),
                source: "binance",
                side: get_random(["buy"]),
                minimum_size: 0.001,
                maximum_size: 0.001,
                spread: randomFromInterval(0.1, 0.1),
                timer: Math.floor(randomFromInterval(10, 25)),
                source_symbol: get_random(["BTC/USDT"]),
                rebalance_symbol: "BTC/USDT",
                conversion: null,
                logs: [],
                rebalance: {
                    exchange: "binanceusdm",
                    api_key: "1a3321381e9f2e87cdc1a2e9489936bb0e5e059043617ff723508a2b0d6cd575",
                    api_secret: "0aa570260b8082e9130030eae9fefefee70e55bde31865494224b124983b3aed"
                },
                bot_id: selectedBot.id,
                expanded: false,
                saved: true,
            },
        ]

        setOrders([...orders, get_random(randomOrder)]);

    }

    const onChangeSource = (source, source_symbol, custom_uniswap_symbol = null, selected_network = null, isSandbox, customUrl = null, scriptId = null, customMarketConfig = null, conversionMarket = null) => {
        if (!custom_uniswap_symbol) {
            setOrderItem({
                ...orderItem,
                source,
                source_symbol,
                custom_uniswap_symbol: null,
                selected_network,
                isSandbox,
                customUrl: source === 'hollaex' && customUrl,
                scriptId,
                ...(scriptId && { scriptId, source_symbol: "Custom Script" }),
                customMarketConfig: customMarketConfig || null,
                conversionMarket
            })
        } else {
            setOrderItem({
                ...orderItem,
                source_symbol: "Custom Uniswap Symbol",
                custom_uniswap_symbol,
                source,
                selected_network,
                isSandbox,
                customUrl: source === 'hollaex' && customUrl,
                scriptId,
                ...(scriptId && { scriptId, source_symbol: "Custom Script" }),
                customMarketConfig: customMarketConfig || null,
                conversionMarket
            })
        }

    }
    const onChangeRebalanceProfile = (rebalance, rebalance_symbol, custom_uniswap_symbol_rebalance = null, selected_network_rebalance = null, scriptId = null, rebalanceAssetInfo) => {
        if (scriptId) {
            setOrderItem({
                ...orderItem,
                rebalance: { id: scriptId, type: 'custom_script', name: 'Custom Script' },
                ...(scriptId && { rebalance_symbol: "Custom Script" }),
            })
            return;
        }
        if (!rebalance.id) {
            createProfile(rebalance).then((newProfileData) => {
                fetchProfiles().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_PROFILES,
                        payload: res,
                    })
                    rebalance.id = newProfileData.id
                    if (!custom_uniswap_symbol_rebalance) {
                        setOrderItem({
                            ...orderItem,
                            rebalance: { id: rebalance.id, name: rebalance.name },
                            rebalance_symbol,
                            custom_uniswap_symbol_rebalance: null,
                            selected_network_rebalance,
                            ...rebalanceAssetInfo
                        })
                    } else {
                        setOrderItem({
                            ...orderItem,
                            rebalance_symbol: "Custom Uniswap Symbol",
                            custom_uniswap_symbol_rebalance,
                            rebalance: { id: rebalance.id, name: rebalance.name },
                            selected_network_rebalance
                        })
                    }
                })
            })
        } else {
            if (!custom_uniswap_symbol_rebalance) {
                setOrderItem({
                    ...orderItem,
                    rebalance: { id: rebalance.id, name: rebalance.name },
                    rebalance_symbol,
                    custom_uniswap_symbol_rebalance: null,
                    selected_network_rebalance,
                    ...rebalanceAssetInfo
                })
            } else {
                setOrderItem({
                    ...orderItem,
                    rebalance_symbol: "Custom Uniswap Symbol",
                    custom_uniswap_symbol_rebalance,
                    rebalance: { id: rebalance.id, name: rebalance.name },
                    selected_network_rebalance
                })
            }
        }

        console.log({ rebalance, rebalance_symbol, rebalanceAssetInfo })
    }
    const onCreateConversion = (conversion) => {
        setOrderItem({
            ...orderItem,
            conversion
        })
    }

    const onCreateConversionAll = async (conversion) => {
        if (botState === 'play') {
            setBotState('stop');
            message.destroy(key);
            const symbols = [];
            for (const order of orders.filter(order => order?.bot_id === selectedBot.id)) {
                if (symbols.indexOf(order.symbol) === -1) {
                    symbols.push(order.symbol);
                }
            }
            await updateBot(selectedBot.id, { active: false, symbols })

            const res = await fetchBots();

            dispatch({
                type: APP_ACTIONS.SET_BOTS,
                payload: res,
            })

            // this will cancell all orders
            await cancelOrder(null, false, true, selectedBot.id);

            orders.filter(order => order?.bot_id === selectedBot.id).forEach(order => {
                // cancelOrder(order.id, false);
                order.expanded = false;
                order.logs = [];
                order.conversion = conversion;
            })
            startPlay();
        } else {
            orders.filter(order => order?.bot_id === selectedBot.id).forEach(order => {
                // cancelOrder(order.id, false);
                order.expanded = false;
                order.logs = [];
                order.conversion = conversion;
            })
        }
    }

    const startPlay = (individualOrder = null) => {
        if (orders.filter(order => order?.bot_id === selectedBot.id).length > 0) {

            if (individualOrder) {
                orders.filter(order => order?.id === individualOrder.id).forEach(order => {
                    order.expanded = false;
                    order.paused = false
                })
            } else {
                orders.filter(order => order?.bot_id === selectedBot.id).forEach(order => {
                    order.expanded = false;
                    order.paused = false
                })
            }

            setOrders([...orders]);
            setBotState('play');
            openMessage()
            const symbols = [];
            for (const order of orders.filter(order => order?.bot_id === selectedBot.id)) {
                if (symbols.indexOf(order.symbol) === -1) {
                    symbols.push(order.symbol);
                }
            }
            updateBot(selectedBot.id, { active: true, symbols }).then(res => {
                fetchBots().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })
                })

                placeOrders(individualOrder);
            }).catch(err => {
                message.destroy(key);
                message.error({ content: 'something went wrong', key: 'error' });
            })
        } else {
            message.error("There is no strategy to start the bot")
        }

    }
    const stopPlay = () => {
        setBotState('stop');
        message.destroy(key);
        message.destroy("botPause");
        const symbols = [];
        for (const order of orders.filter(order => order?.bot_id === selectedBot.id)) {
            if (symbols.indexOf(order.symbol) === -1) {
                symbols.push(order.symbol);
            }
        }
        updateBot(selectedBot.id, { active: false, symbols }).then(res => {
            fetchBots().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_BOTS,
                    payload: res,
                })
            })
        })
        // this will cancell all orders
        cancelOrder(null, false, true, selectedBot.id);
        orders.filter(order => order?.bot_id === selectedBot.id).forEach(order => {
            // cancelOrder(order.id, false);
            order.expanded = false;
            order.logs = [];
            order.paused = true;
        })
        setOrders([...orders]);
    }

    const openMessage = () => {
        message.loading({ content: 'Waiting...', key, duration: 0 });

    };
    const openNotificationWithIcon = (type, message, description) => {
        notification[type]({
            message,
            description
        });
    };
    const placeOrders = (individualOrder = null) => {
        console.log({ orders })
        createOrders(individualOrder ? [individualOrder] : orders.filter(order => order?.bot_id === selectedBot.id)).then(res => {

            console.log({ placedOrders: res })
        })
    }

    const editOrder = (orderData) => {
        setNewOrderCreate(true);
        setOrders(previousState => {
            let newOrders = [...previousState]
            newOrders.filter(order => order?.bot_id === selectedBot.id).forEach(order => {
                if (order.id === orderData.id) {
                    order.saved = false;
                    setOrderItem({
                        ...order
                    })

                } else {
                    order.saved = true;
                }
            })
            return newOrders;
        })
    }
    const handleRefresh = () => {
        window.location.reload();
    }

    const createAccumulator = () => {
        setNewAccumulatorCreate(true);
        setAccumulators([...accumulators, defaultAccumulatorItem])
    }

    const cancelCreateAccumulator = () => {
        const newAccumulators = [...accumulators];
        if (!accumulatorItem.id) {
            newAccumulators.pop();

        } else {
            newAccumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id).forEach(x => {
                x.saved = true;
            })
        }
        setAccumulatorItem(defaultAccumulatorItem);
        setAccumulators(newAccumulators);
        setNewAccumulatorCreate(false);
    }

    const addAccumulator = (accumulatorItemId = null) => {
        if (!accumulatorItem.interval) {
            message.error("Please enter interval");
            return;
        }
        if (!accumulatorItem.symbol) {
            message.error("Please select market");
            return;
        }

        let newAccumulatorItem = Object.assign({}, accumulatorItem);

        if (!newAccumulatorItem.id) newAccumulatorItem.id = uuidv4();

        let newAccumulators = [...accumulators];
        let Index;
        if (accumulatorItemId) {
            Index = newAccumulators.findIndex(accumulator => !accumulator.saved && accumulator.id == accumulatorItemId);
        } else {
            Index = newAccumulators.findIndex(accumulator => !accumulator.saved);
        }

        newAccumulators[Index] = newAccumulatorItem;
        newAccumulators[Index].saved = true;

        setAccumulators(newAccumulators);
        setNewAccumulatorCreate(false);
        setAccumulatorItem(defaultAccumulatorItem)

        if (botState === 'play') {
            editAccumulators(newAccumulators[Index]);
        }
    }

    const editAccumulator = (accumulatorData) => {
        setNewAccumulatorCreate(true);
        setAccumulators(previousState => {
            let newAccumulators = [...previousState]
            newAccumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id).forEach(accumulator => {
                if (accumulator.id === accumulatorData.id) {
                    accumulator.saved = false;
                    setAccumulatorItem({
                        ...accumulator
                    })

                } else {
                    accumulator.saved = true;
                }
            })
            return newAccumulators;
        })
    }

    const startPlayAccumulate = () => {
        if (accumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id).length > 0) {

            accumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id).forEach(accumulator => {
                accumulator.expanded = false;
                accumulator.paused = false
            })

            setBotState('play');
            openMessage();

            updateBot(selectedBot.id, { active: true, symbols: [] }).then(res => {
                fetchBots().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })
                })

                createAccumulators(accumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id)).then(res => {
                    message.destroy(key);
                })
            }).catch(err => {
                message.destroy(key);
                message.error({ content: 'something went wrong', key: 'error' });
            })

        } else {
            message.error("There is no strategy to start the bot")
        }

    }

    const startPlayTriangular = async () => {
        const strategies = orders.filter(order => order?.bot_id === selectedBot.id && order.saved);

        if (strategies.length === 0) {
            message.error("There is no strategy to start the bot");
            return;
        }

        setBotState('play');
        openMessage();

        const symbols = [];
        for (const strategy of strategies) {
            if (strategy.symbol && symbols.indexOf(strategy.symbol) === -1) {
                symbols.push(strategy.symbol);
            }
        }

        updateBot(selectedBot.id, { active: true, symbols }).then(() => {
            fetchBots().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_BOTS,
                    payload: res,
                })
            })

            createTriangulars(strategies).then(res => {
                message.destroy(key);
                if (res?.error) message.error(res.error);
            })
        }).catch(() => {
            message.destroy(key);
            message.error({ content: 'something went wrong', key: 'error' });
        })
    }

    const stopPlayTriangular = () => {
        setBotState('stop');
        message.destroy(key);

        const symbols = [];
        for (const strategy of orders.filter(order => order?.bot_id === selectedBot.id)) {
            if (strategy.symbol && symbols.indexOf(strategy.symbol) === -1) {
                symbols.push(strategy.symbol);
            }
        }

        // `type` is what tells the bot service to tear the triangular strategies down.
        updateBot(selectedBot.id, { active: false, symbols, type: "triangular" }).then(() => {
            fetchBots().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_BOTS,
                    payload: res,
                })
            })
        }).catch(() => {
            message.destroy(key);
            message.error({ content: 'something went wrong', key: 'error' });
        })
    }

    const stopPlayAccumulate = () => {
        setBotState('stop');
        updateBot(selectedBot.id, { active: false, symbols: [], type: "accumulator" }).then(res => {
            fetchBots().then(res => {
                dispatch({
                    type: APP_ACTIONS.SET_BOTS,
                    payload: res,
                })
            })

            // accumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id).forEach(accumulator => {
            //     accumulator.expanded = false;
            //     accumulator.logs = [];
            // })

        }).catch(err => {
            message.destroy(key);
            message.error({ content: 'something went wrong', key: 'error' });
        })
    }


    // useEffect(() => {

    //     generateLogs();
    //     generateLogsNeg();
    // }, [])

    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }
    const generateLogs = async () => {

        const positives = [
            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap", textOverflow: "ellipsis", overFlow: "hidden" }}>Order Created, XHT/USDT, Size: 10.45, Price:2.24, Buy</span>,
            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap", textOverflow: "ellipsis", overFlow: "hidden" }}>Order Created, BTC/USDT, Size: 0.0001, Price:19.000, Buy</span>,
            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap", textOverflow: "ellipsis", overFlow: "hidden" }}>Order Created, BTC/USDT, Size: 0.0005, Price:20.452, Sell</span>,
            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap", textOverflow: "ellipsis", overFlow: "hidden" }}>Order Created, XHT/USDT, Size: 52.78, Price:2.85, Buy</span>,
            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap", textOverflow: "ellipsis", overFlow: "hidden" }}>Order Created, XHT/USDT, Size: 10.45, Price:2.24, Sell</span>,
            <span style={{ color: "green", fontWeight: "bold", whiteSpace: "nowrap", textOverflow: "ellipsis", overFlow: "hidden" }}>Order Created, BTC/USDT, Size: 0.0025, Price:20.600, Sell</span>,
        ]



        for (let i = 0; i < 100; i++) {

            await sleep(Math.random() * 3 * 1000)

            setSuccessLogs(previousState => {
                let newLogs = [...previousState]

                newLogs.unshift(positives[Math.floor(Math.random() * positives.length)])
                return newLogs;
            })

            setSuccessMinLogs(previousState => {
                let newLogs = [...previousState]
                if (newLogs.length > 4) newLogs.pop();

                newLogs.unshift(positives[Math.floor(Math.random() * positives.length)])
                return newLogs;
            })
        }
    }

    const generateLogsNeg = async () => {

        const negatives = [
            <span style={{ color: "#c11919", fontWeight: "bold", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>Error: Insufficient Funds, Balance, BTC </span>,
            <span style={{ color: "#c11919", fontWeight: "bold", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>Error: Rebalance Profile Insufficint Balance, Strategy: XHT/USDT </span>,
        ]

        for (let i = 0; i < 100; i++) {

            await sleep(Math.random() * 4 * 1000)

            setErrorLogs(previousState => {
                let newLogs = [...previousState]

                newLogs.unshift(negatives[Math.floor(Math.random() * negatives.length)])
                return newLogs;
            })
            setErrorMinLogs(previousState => {
                let newLogs = [...previousState]
                if (newLogs.length > 4) newLogs.pop();

                newLogs.unshift(negatives[Math.floor(Math.random() * negatives.length)])
                return newLogs;
            })
        }
    }
    const configureFilters = (_filters) => {
        setFilters(_filters);
        setEnableFilters(true);
        localStorage.setItem(`filters`, JSON.stringify(_filters));
    }

    const filterResults = (order) => {
        const symbolFilter = filters.find(f => f.field === 'symbol');
        const spreadFilter = filters.find(f => f.field === 'spread');
        const timerFilter = filters.find(f => f.field === 'timer');
        const sideFilter = filters.find(f => f.field === 'side');
        const minimumSizeFilter = filters.find(f => f.field === 'minimum_size');
        const maximumSizeFilter = filters.find(f => f.field === 'maximum_size');
        const sourceFilter = filters.find(f => f.field === 'source');
        const sensitivityFilter = filters.find(f => f.field === 'sensitivity');
        const pausedFilter = filters.find(f => f.field === 'paused');
        const sourceSymbolFilter = filters.find(f => f.field === 'source_symbol');
        const rebalanceSymbolFilter = filters.find(f => f.field === 'rebalance_symbol');
        console.log({ timerFilter })
        return (
            (sideFilter ? order?.side?.toLowerCase()?.includes(sideFilter?.value?.toLowerCase()) : true)
            && (spreadFilter ? (order?.spread >= spreadFilter?.value?.[0] && order?.spread <= spreadFilter?.value?.[1]) : true)
            && (minimumSizeFilter ? (order?.minimum_size >= minimumSizeFilter?.value?.[0] && order?.minimum_size <= minimumSizeFilter?.value?.[1]) : true)
            && (maximumSizeFilter ? (order?.maximum_size >= maximumSizeFilter?.value?.[0] && order?.maximum_size <= maximumSizeFilter?.value?.[1]) : true)
            && (sensitivityFilter ? (order?.sensitivity >= sensitivityFilter?.value?.[0] && order?.sensitivity <= sensitivityFilter?.value?.[1]) : true)
            && (timerFilter ? (order?.timer >= timerFilter?.value?.[0] && order?.timer <= timerFilter?.value?.[1]) : true)
            && (sourceFilter ? order?.source?.toLowerCase()?.includes(sourceFilter?.value?.toLowerCase()) : true)
            && (sourceSymbolFilter ? order?.source_symbol?.toLowerCase()?.includes(sourceSymbolFilter?.value?.toLowerCase()) : true)
            && (rebalanceSymbolFilter ? order?.rebalance_symbol?.toLowerCase()?.includes(rebalanceSymbolFilter?.value?.toLowerCase()) : true)
            && (pausedFilter != null ? order?.paused == pausedFilter?.value : true)
            && (symbolFilter ? order?.symbol?.toLowerCase()?.includes(symbolFilter?.value?.toLowerCase()) : true)
        );
    }

    const applyBulkUpdate = async (updateField) => {

        if (botState === 'play') {
            if (!(updateField?.field === 'paused' && updateField?.value == true)) openMessage();
            orders.filter(order => order?.bot_id === selectedBot.id)
                .filter(order => enableFilters ? filterResults(order) : filter ? (order?.side?.toLowerCase()?.includes(filter?.toLowerCase())
                    || order?.symbol?.toLowerCase()?.includes(filter?.toLowerCase())) : true).forEach(x => {
                        cancelOrder(x.id, false, false, selectedBot.id)

                    })

        }

        orders.filter(order => order?.bot_id === selectedBot.id)
            .filter(order => enableFilters ? filterResults(order) : filter ? (order?.side?.toLowerCase()?.includes(filter?.toLowerCase())
                || order?.symbol?.toLowerCase()?.includes(filter?.toLowerCase())) : true)?.forEach(order => {
                    if (order.hasOwnProperty(updateField?.field)) order[updateField?.field] = updateField.value

                    if (botState === 'play') {

                        let Index = orders.findIndex(x => x.id === order.id);
                        const logLength = orders[Index]?.logs?.length;
                        const lastLog = Object.assign({}, orders[Index]?.logs?.[logLength - 1]);
                        const clone = Object.assign({}, orders[Index]);
                        delete clone.logs;
                        if (lastLog?.order_status === 'closed' || lastLog?.order_status === 'filled') {
                            clone.order_status = 'closed';
                            if (!(updateField?.field === 'paused' && updateField?.value == true)) cancelOrderAndUpdate(lastLog.id, clone)
                        } else {
                            if (!(updateField?.field === 'paused' && updateField?.value == true)) createOrders([clone])
                        }
                    }
                    if ((updateField?.field === 'paused' && updateField?.value == true)) {
                        order.logs = [];
                    }
                })
        setOrders([...orders]);

    }

    return (
        <>
            {displayBalanceSection && <Balance selectedBot={selectedBot} setDisplayBalanceSection={setDisplayBalanceSection} botState={botState} />}
            {displayHistorySection && <History selectedBot={selectedBot} setDisplayHistorySection={setDisplayHistorySection} />}
            {displayStatusSection && <Status selectedBot={selectedBot} setDisplayStatusSection={setDisplayStatusSection} />}
            {displayCaseViewerSection && <EdgeCaseViewer selectedBot={selectedBot} setDisplayCaseViewerSection={setDisplayCaseViewerSection} />}

            {serverUnresponsive ? <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", color: "white", gap: 10, fontSize: 20, textAlign: "center", marginTop: 30 }}>
                Client disconnected from server, please refresh
                <Button onClick={() => { handleRefresh() }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }}>Refresh</Button>
            </div>
                :
                <div style={{ display: displayBalanceSection || displayHistorySection || displayStatusSection || displayCaseViewerSection ? "none" : "block" }}>
                    {displaySelectSource && <SelectSource selectedBot={selectedBot} displaySelectSource={displaySelectSource} setDisplaySelectSource={setDisplaySelectSource} onChangeSource={onChangeSource} orderItem={orderItem} savedScripts={customScripts} />}
                    {displayRebalanceProfile && <SelectRebalanceProfile displayRebalanceProfile={displayRebalanceProfile} setDisplayRebalanceProfile={setDisplayRebalanceProfile} onChangeRebalanceProfile={onChangeRebalanceProfile} orderItem={orderItem} setOrderItem={setOrderItem} savedScripts={customScripts} />}
                    {displayCreateConversion && <CreateConversion displayCreateConversion={displayCreateConversion} setDisplayCreateConversion={setDisplayCreateConversion} onCreateConversion={onCreateConversion} currentConversion={orderItem.conversion} />}
                    {/* {displayCreateConversionAll && <CreateConversion displayCreateConversion={displayCreateConversionAll} setDisplayCreateConversion={setDisplayBulkUpdate} onCreateConversion={onCreateConversionAll} />} */}
                    {<BulkUpdate displayBulkUpdate={displayBulkUpdate} setDisplayBulkUpdate={setDisplayBulkUpdate} applyBulkUpdate={applyBulkUpdate} markets={markets} />}

                    {displayAddAlert && <AddAlert displayAddAlert={displayAddAlert} setDisplayAddAlert={setDisplayAddAlert} selectedBot={selectedBot} />}
                    <Modal bodyStyle={{
                        backgroundColor: 'black',
                        border: "1px solid grey"
                    }}
                        visible={displayWarning} footer={null} onCancel={() => { setDisplayWarning(false); }}>

                        <div style={{ fontWeight: "600", color: "white" }}>{warningType === 'start' ? <>
                            <svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="8.455" height="15.954" viewBox="0 0 11.455 19.954">
                                <path id="Path_6003" data-name="Path 6003" d="M295.921,175.519l-8.5-8.5a1.478,1.478,0,0,0-2.523,1.045v17a1.478,1.478,0,0,0,2.523,1.045l8.5-8.5a1.478,1.478,0,0,0,0-2.09Z" transform="translate(-284.899 -166.587)" fill="#fff" />
                            </svg> Start play</> :
                            <><svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="10.794" height="16.611" viewBox="0 0 15.794 22.611">
                                <path id="Path_6004" data-name="Path 6004" d="M280.166,173.6h-2.7a1.785,1.785,0,0,0-1.785,1.785v19.04a1.785,1.785,0,0,0,1.785,1.785h2.7a1.785,1.785,0,0,0,1.785-1.785v-19.04a1.784,1.784,0,0,0-1.785-1.785Zm9.52,0h-2.7a1.785,1.785,0,0,0-1.785,1.785v19.04a1.785,1.785,0,0,0,1.785,1.785h2.7a1.785,1.785,0,0,0,1.785-1.785v-19.04a1.784,1.784,0,0,0-1.785-1.785Z" transform="translate(-275.678 -173.6)" fill="#fff" />
                            </svg>
                                Stop play
                            </>
                        }</div>
                        <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                            {warningType === 'start'
                                ? `Are you sure you want to turn on play for all '${selectedBot.name}' bot strategies?`
                                : `Are you sure you want to ${exit ? 'exit' : 'stop'} all '${selectedBot.name}' strategies?`
                            }
                        </div>


                        <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                            <Button onClick={() => { setDisplayWarning(false); setExist(false) }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NO</Button>
                            <Button onClick={() => {
                                if (warningType === 'start') {
                                    if (selectedBot.type === 'marketmaker') {
                                        startPlay();
                                    } else if (selectedBot.type === 'triangular') {
                                        startPlayTriangular();
                                    } else {
                                        startPlayAccumulate();
                                    }

                                } else {
                                    if (selectedBot.type === 'marketmaker') {
                                        stopPlay();
                                    } else if (selectedBot.type === 'triangular') {
                                        stopPlayTriangular();
                                    } else {
                                        stopPlayAccumulate();
                                    }

                                    if (exit) {
                                        setDisplayAdvancedSection(false)
                                    }
                                }
                                setDisplayWarning(false);
                            }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">YES</Button>
                        </div>
                    </Modal>

                    {showAdvancedFilter && <AdvancedFilter showAdvancedFilter={showAdvancedFilter} setShowAdvancedFilter={setShowAdvancedFilter} currentFilters={filters} configureFilters={configureFilters} />}
                    <Modal bodyStyle={{
                        backgroundColor: 'black',
                        border: "1px solid grey"
                    }}
                        visible={displayAdvancedConfig} maskClosable={false} footer={null} onCancel={() => { setDisplayAdvancedConfig(false); }}>

                        <div style={{ fontWeight: "600", color: "white" }}>Advanced Options </div>

                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label>	Sensitivity(%)</label>
                            <Input value={orderItem.sensitivity} onChange={(e) => {
                                setOrderItem({
                                    ...orderItem,
                                    sensitivity: e.target.value
                                })
                            }} style={{ marginTop: 10 }} placeholder="Enter Sensitivity" />
                        </div>

                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label>Order recreation cooldown period after trade(sec)</label>
                            <Input value={orderItem.cooldown_period} onChange={(e) => {
                                setOrderItem({
                                    ...orderItem,
                                    cooldown_period: e.target.value
                                })
                            }} style={{ marginTop: 10 }} placeholder="Enter Cooldown Period" />
                        </div>

                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label>Order price increment unit</label>
                            <Input value={orderItem?.price_increment_unit} onChange={(e) => {
                                setOrderItem({
                                    ...orderItem,
                                    price_increment_unit: e.target.value
                                })
                            }} style={{ marginTop: 10 }} placeholder="Enter Price increment unit" />
                        </div>

                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label>Skip rebalance check</label>
                            <Switch size="medium" style={{ marginLeft: 5 }} checked={orderItem?.hasRebalanceCheck} onChange={(e) => {
                                setOrderItem({
                                    ...orderItem,
                                    hasRebalanceCheck: e
                                })
                            }} />

                        </div>

                        <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>

                            <Button onClick={() => {
                                setDisplayAdvancedConfig(false);
                            }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
                        </div>
                    </Modal>

                    <div style={{
                        display: displayLogs ? "block" : "none",
                        width: "80%",
                        // height: 700,
                        border: "1px solid white",
                        // overflow:"auto",
                        opacity: 1,
                        backgroundColor: "#0D1017",
                        // justifyContent: "center",
                        position: "absolute",
                        zIndex: 1000,
                        top: "10%",
                        left: "10%",
                    }}

                    >
                        <div style={{ position: "absolute", top: 0, right: 10, color: "white", fontSize: 25, cursor: "pointer" }} onClick={() => { setDisplayLogs(false); }}>X</div>

                        <div style={{ display: 'flex', width: "80%", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end", padding: 3, margin: "0 auto" }}>

                            <span style={{ width: "50%", height: 700, overflow: "auto", color: "white", fontSize: 13, display: "flex", flexDirection: "column", position: "relative", top: 4, alignItems: "flex-start", justifyContent: "flex-start" }}>
                                {successLogs}
                            </span>
                            <span style={{
                                width: "50%", height: 700, overflow: "auto", color: "white", fontSize: 13,
                                //  display:"flex", flexDirection:"column",
                                position: "relative", top: 4, alignItems: "flex-start", justifyContent: "flex-start"
                            }}>
                                {errorLogs}
                            </span>

                        </div>

                    </div>

                    <div style={{ height: "90%" }}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15, }}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="61.474" viewBox="0 0 50 61.474">
                                    <g id="Group_31" data-name="Group 31" transform="translate(-43.472 -151)">
                                        <path id="Path_5804" data-name="Path 5804" d="M272.791,176.36a24.858,24.858,0,0,0-25,24.654v23.321a2.04,2.04,0,0,0,2.054,2.026h45.89a2.041,2.041,0,0,0,2.054-2.026l0-23.321a24.857,24.857,0,0,0-25-24.654ZM251.9,201.014a20.771,20.771,0,0,1,20.89-20.6,20.987,20.987,0,0,1,7.327,1.333,25.293,25.293,0,0,0-19.14,22.586,8.342,8.342,0,0,0-6.156,6H251.9Zm11.04,7.131a4.216,4.216,0,1,1-4.275,4.216A4.25,4.25,0,0,1,262.941,208.145Zm30.739,14.162H251.9v-7.919h2.92a8.4,8.4,0,0,0,16.237,0h22.62v7.919Zm0-11.972H271.059a8.338,8.338,0,0,0-5.975-5.957,21.306,21.306,0,0,1,20.84-19.363,20.456,20.456,0,0,1,7.756,16Zm-10.427-22.015a2.008,2.008,0,0,0-.062,2.865,14.042,14.042,0,0,1,4,9.828,2.054,2.054,0,0,0,4.109,0,18.043,18.043,0,0,0-5.146-12.631,2.071,2.071,0,0,0-2.9-.062Z" transform="translate(-204.318 -13.886)" fill="#8b8b8b" />
                                        <rect id="Rectangle_20" data-name="Rectangle 20" width="5" height="11" rx="2.5" transform="translate(70 155)" fill="#8b8b8b" />
                                        <rect id="Rectangle_21" data-name="Rectangle 21" width="5" height="17" rx="2.5" transform="translate(55 151)" fill="#8b8b8b" />
                                    </g>
                                </svg>
                                <div style={{ color: "grey", fontSize: 17, textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                    // setExist(true); setWarningType('stop'); setDisplayWarning(true) 
                                    setDisplayAdvancedSection(false)
                                }}>My bot list {'>'} Advanced {'>'} </div>
                                <div style={{ position: "relative", top: 3, cursor: "default" }}>
                                    <div style={{ color: "white" }}>{selectedBot?.name} </div>
                                    <div style={{ fontSize: 13, color: "grey" }} >{selectedBot?.description || "-"}</div>
                                </div>

                            </div>
                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                {/* <Button style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">REBALANCE</Button> */}

                                <Badge dot={bots?.find(bot => bot.id === selectedBot.id)?.notificationAlert} style={{ width: 14, height: 14 }}>
                                    <Button onClick={() => {
                                        setDisplayBalanceSection(false);
                                        setDisplayHistorySection(false);
                                        setDisplayStatusSection(false);
                                        setDisplayCaseViewerSection(true);

                                    }} style={{ backgroundColor: "#161616", color: "white", height: 50 }} type="default">
                                        EDGE CASE VIEWER</Button>
                                </Badge>

                                {selectedBot.type === 'marketmaker'
                                    &&
                                    <Button onClick={() => {
                                        setDisplayBalanceSection(false);
                                        setDisplayHistorySection(false);
                                        setDisplayStatusSection(true);

                                    }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">STATUS</Button>
                                }


                                <Button onClick={() => {
                                    setDisplayBalanceSection(true);
                                    setDisplayHistorySection(false);
                                    setDisplayStatusSection(false);

                                }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">BALANCE</Button>
                                {selectedBot.type === 'marketmaker' &&
                                    <Button onClick={() => {
                                        setDisplayBalanceSection(false);
                                        setDisplayHistorySection(true);
                                        setDisplayStatusSection(false);
                                    }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">HISTORY</Button>}

                                {selectedBot.type === 'marketmaker' &&
                                    <Button onClick={() => { setDisplayBulkUpdate(true); }} style={{ backgroundColor: "#161616", color: "white", width: 180, height: 50 }} type="default">BULK UPDATE</Button>
                                }

                                <Button onClick={() => { setDisplayAddAlert(true); }} style={{ backgroundColor: "#161616", color: "white", width: 180, height: 50 }} type="default">ADD ALERTS</Button>
                            </div>
                        </div>
                        <hr style={{ width: "99%", backgroundColor: "white", textAlign: "center" }} />

                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "0 10px", marginTop: 10 }}>
                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="70.918" height="55" viewBox="0 0 97.918 85">
                                    <path id="Path_6012" data-name="Path 6012" d="M307.155,231.91h-81V163.376a2.984,2.984,0,1,0-5.969,0V231.91h-4.975a2.984,2.984,0,0,0,0,5.969h4.975v4.529a2.984,2.984,0,1,0,5.969,0v-4.529h81.006a2.985,2.985,0,1,0,0-5.97Zm-49.978-23.4a2.967,2.967,0,0,0-2.945-.486l-21.017,7.93a2.985,2.985,0,0,0,2.107,5.585l19.4-7.323,10.592,8.69a2.98,2.98,0,0,0,3.273.34l29.66-15.478,1.542,6.618,5.948-14.35-15.4-2.028,4.905,4.593-27.665,14.438Zm-22.908.874a2.975,2.975,0,0,0,2.1-.866L254.764,190.3l12.871,5.942a2.981,2.981,0,0,0,3.483-.729l19.866-22.346,3.639,5.714.854-15.507-15.2,3.191,6.174,2.718-18.322,20.61-12.739-5.88a2.983,2.983,0,0,0-3.354.591L232.166,204.28a2.984,2.984,0,0,0,2.1,5.1Z" transform="translate(-212.225 -160.392)" fill="#fff" opacity="0.5" />
                                </svg>

                                <div>
                                    <div style={{ fontWeight: "600", color: "white", marginBottom: 5 }}>STRATEGY {botState === 'play' && <span style={{ position: "relative", backgroundColor: "red", color: "white", fontWeight: "400", fontSize: 10, padding: 1, left: 2, bottom: 5 }}>Live</span>} </div>
                                    <div style={{ fontWeight: "500", color: "white", marginBottom: 5 }}>EXCHANGE API PROFILE: <span style={{ color: "grey" }}>{selectedBot?.host?.name}</span></div>
                                </div>

                            </div>
                            <div style={{
                                display: "flex",
                                width: "40%",
                                height: 65,
                                border: "1px solid white",
                                overflow: "hidden",
                                opacity: 1,
                                backgroundColor: "#0D1017",
                                justifyContent: "center",
                                cursor: "pointer",
                                position: "relative"
                            }}

                                onClick={() => { setDisplayLogs(true); }}
                            >
                                <div style={{ display: 'flex', flexDirection: "row", width: "90%", justifyContent: "space-between", gap: 10, overflow: "hidden", alignItems: "flex-end", padding: 3 }}>
                                    <div style={{ width: "50%", color: "white", fontSize: 10, overflow: "hidden", display: "flex", flexDirection: "column", position: "relative", top: 5, alignItems: "flex-start", justifyContent: "flex-start" }}>
                                        {successMinLogs}
                                        <div style={{ border: "1px solid white", width: "100%", height: 1 }}></div>
                                    </div>
                                    <div style={{ width: "50%", color: "white", fontSize: 10, overflow: "hidden", display: "flex", flexDirection: "column", position: "relative", top: 5, alignItems: "flex-start", justifyContent: "flex-start" }}>
                                        {errorMinLogs}
                                        <div style={{ border: "1px solid white", width: "100%", height: 1 }}></div>
                                    </div>

                                </div>
                                <div onClick={(e) => {
                                    e.preventDefault(); e.stopPropagation();
                                    setSuccessMinLogs([]);
                                    setErrorMinLogs([]);
                                    setSuccessLogs([]);
                                    setErrorLogs([]);

                                    dispatch({
                                        type: APP_ACTIONS.SET_BOT_LOGS_CLEAR,
                                        payload: {},
                                    })
                                }} style={{ color: "white", position: "absolute", right: 5, }}>Clear</div>
                            </div>




                            <div style={{ display: "flex", flexDirection: "row", gap: 10, }}>
                                <div>
                                    <SearchOutlined style={{ color: "white", position: "relative", left: 25, zIndex: 10 }} />
                                    <Input
                                        onChange={(e) => {
                                            setFilter(e.target.value);
                                        }}
                                        placeholder="Search Strategy"
                                        style={{
                                            paddingLeft: 30,
                                            backgroundColor: "#161616", background: "#161616", color: "white", width: 200, height: 50
                                        }}
                                    // prefix={<SearchOutlined style={{ backgroundColor: "#161616", background: "#161616", color: "white" }} />}
                                    />
                                    {selectedBot.type === 'marketmaker' &&
                                        <div
                                            style={{ textDecoration: 'underline', color: 'white', position: 'relative', left: 15, cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
                                            <span onClick={() => {
                                                setShowAdvancedFilter(true);
                                            }} >Advanced Filter</span>

                                            <span style={{ position: 'relative', right: 20, }}><Switch size="small" checked={enableFilters} onChange={(e) => {
                                                setEnableFilters(e);
                                            }} /></span>

                                        </div>}
                                </div>

                                <Button disabled={botState === 'stop'} onClick={() => { setWarningType('stop'); setDisplayWarning(true); }} style={{ backgroundColor: "#161616", color: botState === 'stop' ? "grey" : "white", width: 120, height: 50 }} type="default">STOP <PauseOutlined style={{ fontSize: 20, position: "relative", top: 3 }} /></Button>
                                <Button disabled={botState === 'play'} onClick={() => { setWarningType('start'); setDisplayWarning(true) }} style={{ backgroundColor: "#161616", color: botState === 'stop' ? "white" : "grey", width: 120, height: 50 }} type="default">PLAY <CaretRightOutlined style={{ fontSize: 20, position: "relative", top: 3 }} /></Button>
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", height: "85%", width: "100%", padding: 10 }}>
                            <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                                <div style={{
                                    // maxHeight: 800,
                                    height: "100%",
                                    overflowY: "auto", overflowX: "auto"
                                }}>


                                    {selectedBot.type === 'triangular' &&
                                        <Triangular
                                            selectedBot={selectedBot}
                                            orders={orders}
                                            setOrders={setOrders}
                                            botState={botState}
                                            disableAction={disableAction}
                                            setDisableAction={setDisableAction}
                                            userId={userId}
                                        />
                                    }

                                    {selectedBot.type !== 'triangular' &&
                                    <table
                                        style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 13px", position: "relative", top: -20 }}>
                                        <thead>
                                            {selectedBot.type === 'marketmaker' &&
                                                <tr style={{ position: "relative", top: 14, fontSize: 16 }}>
                                                    <th style={{ ...tableHeaderStyle, width: "9%" }} >MARKET FOCUS</th>
                                                    <th style={{ ...tableHeaderStyle, width: "6%" }} >SIDE</th>
                                                    <th style={{ ...tableHeaderStyle, width: "9%" }} >SOURCE (PLATFORM)</th>
                                                    <th style={{ ...tableHeaderStyle, width: "9%" }} >SOURCE (SYMBOL)</th>
                                                    <th style={{ ...tableHeaderStyle, width: "6%" }} >MIN SIZE</th>
                                                    <th style={{ ...tableHeaderStyle, width: "6%" }} >MAX SIZE</th>
                                                    <th style={{ ...tableHeaderStyle, width: "6%" }} >SPREAD%</th>
                                                    {/* <th style={{ ...tableHeaderStyle, width: "6%" }} >SENSITIVITY</th> */}
                                                    <th style={{ ...tableHeaderStyle, width: "6%" }} >TIMER (SEC)</th>
                                                    <th style={{ ...tableHeaderStyle, width: "8%" }} >CONVERSION</th>
                                                    <th style={{ ...tableHeaderStyle, width: "10%" }} >REBALANCE (PROFILE)</th>
                                                    <th style={{ ...tableHeaderStyle, width: "10%" }} >REBALANCE (SYMBOL)</th>
                                                    <th style={{ ...tableHeaderStyle, width: "7%" }} >BALANCE LIMIT</th>
                                                    <th style={{ ...tableHeaderStyle, width: "9%" }} >ACTION</th>
                                                    {/* <th style={{ ...tableHeaderStyle, width: "2%", position: 'relative', right: 50 }} ><MenuUnfoldOutlined onClick={() => { setDisplayAdvancedConfig(true) }} style={{ fontSize: 20, cursor: "pointer" }} /></th> */}
                                                </tr>
                                            }

                                            {selectedBot.type === 'accumulator' &&
                                                <tr style={{ position: "relative", top: 14, fontSize: 16 }}>
                                                    <th style={{ ...tableHeaderStyle, width: "40%" }} >MARKET FOCUS</th>
                                                    {/* <th style={{ ...tableHeaderStyle, paddingLeft: 50 }} >SIDE</th>
                                                <th style={{ ...tableHeaderStyle, paddingLeft: 50 }} >SIZE</th> */}
                                                    <th style={{ ...tableHeaderStyle, width: "40%" }} >INTERVAL (SEC)</th>
                                                    <th style={{ ...tableHeaderStyle, width: "20%" }} >ACTION</th>
                                                </tr>
                                            }
                                        </thead>


                                        <DragDropContext onDragEnd={handleDrop}>
                                            <Droppable droppableId="droppable-1">
                                                {(provided) => (
                                                    <tbody
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                    >
                                                        {orders.filter(order => order?.bot_id === selectedBot.id)
                                                            .filter(order => enableFilters ? (filterResults(order) || order.id == null) : filter ? (order?.side?.toLowerCase()?.includes(filter?.toLowerCase())
                                                                || order?.symbol?.toLowerCase()?.includes(filter?.toLowerCase()) || order.id == null) : true).map((x, index) => {
                                                                    const subTable = (botState === 'play' && !x.paused && x.saved) && <tr style={{ height: x.expanded ? 150 : 75 }}>
                                                                        <div id={`subtable${index}`} style={{ overflow: "hidden", backgroundColor: "#222222", marginLeft: 40, width: "95%", position: "absolute", height: x.expanded ? 150 : 75, overflowY: x.expanded ? "auto" : "hidden", paddingLeft: 45 }}>
                                                                            <div
                                                                                onClick={() => {
                                                                                    let newOrders = [...orders];
                                                                                    let Index = newOrders.findIndex(order => order.id === x.id);
                                                                                    if (Index !== -1) {
                                                                                        newOrders[Index].expanded = !newOrders[Index].expanded;
                                                                                        if (!newOrders[Index].expanded) {
                                                                                            const subElement = document.getElementById(`subtable${index}`);
                                                                                            if (subElement) {
                                                                                                subElement.scrollTop = 0;
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                    setOrders(newOrders)

                                                                                }}
                                                                                style={{
                                                                                    border: "1px solid white",
                                                                                    width: 20,
                                                                                    height: 20,
                                                                                    color: "white",
                                                                                    position: "absolute",
                                                                                    left: 10,
                                                                                    bottom: 8,
                                                                                    textAlign: "center",
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                    cursor: "pointer"
                                                                                }}>{x.expanded ? "-" : "+"}</div>
                                                                            <table style={{ width: "100%", position: "relative", top: 5, borderCollapse: "separate", borderSpacing: "0 4px", }}>
                                                                                <tr style={{ fontSize: 16 }}>
                                                                                    {/* <th style={tableSubHeaderStyle} >MARKET/SYMBOL</th> */}
                                                                                    {/* <th style={tableSubHeaderStyle} >SIDE(OFFER)</th> */}
                                                                                    <th style={tableSubHeaderStyle} >PRICE</th>
                                                                                    <th style={tableSubHeaderStyle} >AMOUNT/SIZE</th>
                                                                                    <th style={tableSubHeaderStyle} >REMAINING</th>
                                                                                    {/* <th style={tableSubHeaderStyle} >SOURCE(PLATFORM)</th> */}
                                                                                    {/* <th style={tableSubHeaderStyle} >SOURCE(SYMBOL)</th> */}
                                                                                    {/* <th style={tableSubHeaderStyle} >SPREAD%</th> */}
                                                                                    <th style={tableSubHeaderStyle} >SENSITIVITY</th>
                                                                                    <th style={tableSubHeaderStyle} >TIMELEFT</th>
                                                                                    <th style={tableSubHeaderStyle} >TIME PLACED</th>
                                                                                    <th style={tableSubHeaderStyle} >ACTION</th>
                                                                                </tr>
                                                                                {x.logs.slice().reverse().map(log =>
                                                                                    <TableRow log={log} x={x} disableAction={disableAction} setDisableAction={setDisableAction} cancelOrder={cancelOrder} setOrders={setOrders} botId={selectedBot.id} />
                                                                                )}
                                                                            </table>
                                                                        </div>
                                                                    </tr>
                                                                    if (x.saved) {
                                                                        return <>
                                                                            <Draggable key={x.id} draggableId={x.id} index={index}>
                                                                                {(provided) => (
                                                                                    <>
                                                                                        <tr
                                                                                            style={{ marginTop: 10 }}
                                                                                            className="item-container"
                                                                                            ref={provided.innerRef}
                                                                                            {...provided.draggableProps}
                                                                                        >
                                                                                            <td style={{ ...tableRowStyle, position: "relative" }}>
                                                                                                <span  {...provided.dragHandleProps} style={{ display: botState !== 'play' ? 'inline-block' : 'none', color: "white", fontSize: 20, textAlign: 'center', marginRight: 5 }}>
                                                                                                    <svg style={{ position: "relative", top: 1 }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                                                                        <g id="Group_4612" data-name="Group 4612" transform="translate(3183.743 -12940.257)" opacity="0.4">
                                                                                                            <circle id="Ellipse_8" data-name="Ellipse 8" cx="2" cy="2" r="2" transform="translate(-3183.743 12940.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_10" data-name="Ellipse 10" cx="2" cy="2" r="2" transform="translate(-3183.743 12946.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_12" data-name="Ellipse 12" cx="2" cy="2" r="2" transform="translate(-3183.743 12952.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_9" data-name="Ellipse 9" cx="2" cy="2" r="2" transform="translate(-3177.743 12940.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_15" data-name="Ellipse 15" cx="2" cy="2" r="2" transform="translate(-3171.743 12940.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_11" data-name="Ellipse 11" cx="2" cy="2" r="2" transform="translate(-3177.743 12946.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_14" data-name="Ellipse 14" cx="2" cy="2" r="2" transform="translate(-3171.743 12946.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_13" data-name="Ellipse 13" cx="2" cy="2" r="2" transform="translate(-3177.743 12952.257)" fill="#fff" />
                                                                                                            <circle id="Ellipse_16" data-name="Ellipse 16" cx="2" cy="2" r="2" transform="translate(-3171.743 12952.257)" fill="#fff" />
                                                                                                        </g>
                                                                                                    </svg>
                                                                                                </span>
                                                                                                {x.symbol || '-'}
                                                                                                {(botState === 'play' && !x.paused) && <>
                                                                                                    <div style={{ height: x.expanded ? 158 : 80, width: 1, borderLeft: "2px dashed", left: 19, position: "absolute" }}></div>
                                                                                                    <div style={{ height: 1, width: 15, borderBottom: "2px dashed", position: "absolute", bottom: x.expanded ? -149 : -71, left: 23 }}></div>
                                                                                                </>}

                                                                                            </td>
                                                                                            <td style={tableRowStyle} >{x.side && x.side === 'buy' ?
                                                                                                <span>
                                                                                                    <svg style={{ marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10">
                                                                                                        <path id="Polygon_4" data-name="Polygon 4" d="M8.5,0,17,10H0Z" fill="#00c20d" />
                                                                                                    </svg>
                                                                                                    {x.side}
                                                                                                </span>

                                                                                                :
                                                                                                <span>
                                                                                                    <svg style={{ marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10">
                                                                                                        <path id="Polygon_5" data-name="Polygon 5" d="M8.5,0,17,10H0Z" transform="translate(17 10) rotate(180)" fill="#ff1010" />
                                                                                                    </svg>
                                                                                                    {x.side}
                                                                                                </span>

                                                                                                || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.source || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.source_symbol || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.minimum_size || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.maximum_size || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.spread == null ? '-' : x.spread}</td>
                                                                                            {/* <td style={tableRowStyle} >{x.sensitivity == null ? '-' : x.sensitivity}</td> */}
                                                                                            <td style={tableRowStyle} >{x.timer || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.conversion || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x?.rebalance?.name || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.rebalance_symbol || '-'}</td>
                                                                                            <td style={tableRowStyle} >{x.balance_limit || '-'}</td>
                                                                                            <td style={tableRowStyle} >
                                                                                                <div style={{ display: "flex", flexDirection: "row", padding: 5, gap: 5 }}>
                                                                                                    {botState === 'play' && <span>
                                                                                                        <Button
                                                                                                            onClick={() => {
                                                                                                                let Index = orders.findIndex(order => order.id === x.id);
                                                                                                                if (x.paused) {
                                                                                                                    openMessage();
                                                                                                                    let newOrders = [...orders];
                                                                                                                    newOrders[Index].paused = false
                                                                                                                    setOrders(newOrders);

                                                                                                                    const logLength = newOrders[Index]?.logs?.length;
                                                                                                                    const lastLog = Object.assign({}, newOrders[Index]?.logs?.[logLength - 1]);
                                                                                                                    const clone = Object.assign({}, newOrders[Index]);
                                                                                                                    delete clone.logs;
                                                                                                                    if (lastLog?.order_status === 'closed' || lastLog?.order_status === 'filled') {
                                                                                                                        clone.order_status = 'closed';
                                                                                                                        cancelOrderAndUpdate(lastLog.id, clone)
                                                                                                                    } else {
                                                                                                                        createOrders([clone])
                                                                                                                    }
                                                                                                                } else {
                                                                                                                    let newOrders = [...orders];
                                                                                                                    newOrders[Index].paused = true
                                                                                                                    newOrders[Index].logs = [];
                                                                                                                    newOrders[Index].expanded = false;
                                                                                                                    setOrders(newOrders);

                                                                                                                    cancelOrder(x.id, false, false, selectedBot.id)
                                                                                                                }
                                                                                                            }}
                                                                                                            style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>{x.paused ? 'Play' : 'Pause'}</Button>
                                                                                                    </span>}

                                                                                                    {botState === 'stop' &&
                                                                                                        <Button
                                                                                                            onClick={() => {
                                                                                                                startPlay(x);
                                                                                                            }}
                                                                                                            style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>Play</Button>
                                                                                                    }

                                                                                                    <span><Button
                                                                                                        onClick={() => {
                                                                                                            let newOrder = JSON.parse(JSON.stringify(x));
                                                                                                            if (newOrder.logs) newOrder.logs = [];
                                                                                                            let originalId = newOrder.id;
                                                                                                            newOrder.id = uuidv4();
                                                                                                            // sendUnprocessOrder(JSON.parse(JSON.stringify(newOrder)), 'add', originalId);
                                                                                                            setOrders(previousState => {
                                                                                                                let newOrders = [...previousState];
                                                                                                                let foundIndex = newOrders.findIndex(x => x.id == originalId);
                                                                                                                newOrders.splice(foundIndex + 1, 0, newOrder);
                                                                                                                // newOrders.push(newOrder);
                                                                                                                return newOrders;
                                                                                                            })
                                                                                                            if (botState === 'play') {
                                                                                                                message.loading({ content: 'Waiting...', key, duration: 0 });
                                                                                                                createOrders([newOrder])
                                                                                                            }

                                                                                                        }}
                                                                                                        style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>Duplicate</Button></span>



                                                                                                    <span><Button
                                                                                                        onClick={() => {
                                                                                                            message.destroy('cancel');
                                                                                                            editOrder(x);
                                                                                                        }}
                                                                                                        style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>Edit</Button></span>
                                                                                                    <span>
                                                                                                        <Popconfirm placement="left" title={'Are you sure to delete this strategy?'} onConfirm={() => {
                                                                                                            cancelOrder(x.id, false, false, selectedBot.id);

                                                                                                            let newOrders = orders.filter(order => order.id !== x.id);
                                                                                                            // sendUnprocessOrder({ id: x.id, bot_id: selectedBot.id}, 'delete');

                                                                                                            setOrders(newOrders);
                                                                                                            if (newOrders.filter(order => order?.bot_id === selectedBot.id).length === 0) {
                                                                                                                setBotState('stop');
                                                                                                                updateBot(selectedBot.id, { active: false, symbols: [] }).then(res => {
                                                                                                                    fetchBots().then(res => {
                                                                                                                        dispatch({
                                                                                                                            type: APP_ACTIONS.SET_BOTS,
                                                                                                                            payload: res,
                                                                                                                        })
                                                                                                                    })
                                                                                                                })
                                                                                                                // this will cancell all orders
                                                                                                                cancelOrder(null, false, true, selectedBot.id);
                                                                                                            }
                                                                                                        }} okText="Yes" cancelText="No">
                                                                                                            <Button style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}  >Delete</Button>
                                                                                                        </Popconfirm>
                                                                                                    </span>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                        {subTable}
                                                                                    </>
                                                                                )}
                                                                            </Draggable>

                                                                        </>

                                                                    } else {
                                                                        return <>
                                                                            <tr>
                                                                                <td style={tableRowEditStyle}>
                                                                                    <Select
                                                                                        showSearch
                                                                                        placeholder="Symbol"
                                                                                        value={orderItem.symbol}
                                                                                        style={{ color: "black", width: "95%" }}
                                                                                        onChange={(value) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                symbol: value,
                                                                                                source: null,
                                                                                                source_symbol: null,
                                                                                                conversionMarket: null,
                                                                                                rebalance: null,
                                                                                                rebalance_symbol: null,
                                                                                                rebalanceAssets: null

                                                                                            })
                                                                                        }}
                                                                                    >
                                                                                        {(markets || []).map(market => <Option value={market.symbol}>{market.symbol}</Option>)}

                                                                                    </Select>

                                                                                    {/* <Input value={orderItem.symbol} onChange={(e) => {
                                                        setOrderItem({
                                                            ...orderItem,
                                                            symbol: e.target.value
                                                        })
                                                    }} style={{ color: "black" }} placeholder="Symbol" /> */}
                                                                                </td>
                                                                                <td style={tableRowEditStyle}>
                                                                                    <Select
                                                                                        value={orderItem.side}
                                                                                        onChange={(value) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                side: value
                                                                                            })
                                                                                        }}
                                                                                        placeholder="Side" style={{ backgroundColor: "#1E2329", width: "95%" }}>
                                                                                        <Option value="buy">Buy</Option>
                                                                                        <Option value="sell">Sell</Option>
                                                                                    </Select>
                                                                                </td>
                                                                                <td onClick={() => { setDisplaySelectSource(true) }} style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={sources?.find(x => x.value === orderItem.source)?.label}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Source" />

                                                                                </td>
                                                                                <td onClick={() => { setDisplaySelectSource(true) }} style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem.source_symbol}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Source Symbol" />
                                                                                </td>
                                                                                <td style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem.minimum_size}
                                                                                        onChange={(e) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                minimum_size: e.target.value
                                                                                            })
                                                                                        }}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Minimum Size" />
                                                                                </td>
                                                                                <td style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem.maximum_size}
                                                                                        onChange={(e) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                maximum_size: e.target.value
                                                                                            })
                                                                                        }}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Maximum Size" />
                                                                                </td>
                                                                                <td style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        onChange={(e) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                spread: e.target.value
                                                                                            })
                                                                                        }}
                                                                                        value={orderItem.spread} style={{ color: "black", width: "95%" }} placeholder="Spread" />
                                                                                </td>
                                                                                {/* <td style={tableRowEditStyle}>
                                                            <Input
                                                                value={orderItem.sensitivity}
                                                                onChange={(e) => {
                                                                    setOrderItem({
                                                                        ...orderItem,
                                                                        sensitivity: e.target.value
                                                                    })
                                                                }}
                                                                style={{ color: "black", width: "95%" }} placeholder="Sensitivity" />
                                                        </td> */}

                                                                                <td style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        onChange={(e) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                timer: e.target.value
                                                                                            })
                                                                                        }}
                                                                                        value={orderItem.timer} style={{ color: "black", width: "95%" }} placeholder="Timer" />
                                                                                </td>

                                                                                <td onClick={() => { setDisplayCreateConversion(true) }} onFocus={() => { setDisplayCreateConversion(true) }} style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem.conversion}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Conversion" />
                                                                                </td>

                                                                                <td onClick={() => { setDisplayRebalanceProfile(true) }} style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem?.rebalance?.name}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Rebalance Profile" />
                                                                                </td>
                                                                                <td onClick={() => { setDisplayRebalanceProfile(true) }} style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem.rebalance_symbol}
                                                                                        onChange={(e) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                rebalance_symbol: e.target.value
                                                                                            })
                                                                                        }}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Rebalance Symbol" />
                                                                                </td>

                                                                                <td style={tableRowEditStyle}>
                                                                                    <Input
                                                                                        value={orderItem.balance_limit}
                                                                                        onChange={(e) => {
                                                                                            setOrderItem({
                                                                                                ...orderItem,
                                                                                                balance_limit: e.target.value
                                                                                            })
                                                                                        }}
                                                                                        style={{ color: "black", width: "95%" }} placeholder="Limit" />
                                                                                </td>

                                                                                <td style={tableRowEditStyle}>
                                                                                    <div style={{ fontSize: 15, position: "relative" }}>
                                                                                        <Button
                                                                                            disabled={disableAction}
                                                                                            style={{ backgroundColor: "#161616", color: "white", marginLeft: 4, borderRadius: 10 }}
                                                                                            onClick={() => {
                                                                                                addOrder(x?.id);
                                                                                                // createRandomOrder();
                                                                                            }}>Save</Button>

                                                                                        <span>
                                                                                            <MoreOutlined onClick={() => { setDisplayAdvancedConfig(true) }} style={{ fontSize: 25, color: 'white', cursor: "pointer", position: "absolute", right: 0, top: 1 }} />
                                                                                        </span>

                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            {subTable}
                                                                        </>
                                                                    }

                                                                })}





                                                        {accumulators.filter(accumulator => accumulator?.bot_id === selectedBot.id).filter(accumulator => filter ? (accumulator?.symbol?.toLowerCase()?.includes(filter?.toLowerCase())) : true).map((x, index) => {
                                                            const subTable = (botState === 'play' && !x.paused && x.saved) && <tr style={{ height: x.expanded ? 150 : 75 }}>
                                                                <div id={`subtable${index}`} style={{ overflow: "hidden", backgroundColor: "#222222", marginLeft: 40, width: "95%", position: "absolute", height: x.expanded ? 150 : 75, overflowY: x.expanded ? "auto" : "hidden", paddingLeft: 45 }}>
                                                                    <div
                                                                        onClick={() => {
                                                                            let newAccumulators = [...accumulators];
                                                                            let Index = newAccumulators.findIndex(accumulator => accumulator.id === x.id);
                                                                            if (Index !== -1) {
                                                                                newAccumulators[Index].expanded = !newAccumulators[Index].expanded;
                                                                                if (!newAccumulators[Index].expanded) {
                                                                                    const subElement = document.getElementById(`subtable${index}`);
                                                                                    if (subElement) {
                                                                                        subElement.scrollTop = 0;
                                                                                    }
                                                                                }
                                                                            }
                                                                            setAccumulators(newAccumulators)

                                                                        }}
                                                                        style={{
                                                                            border: "1px solid white",
                                                                            width: 20,
                                                                            height: 20,
                                                                            color: "white",
                                                                            position: "absolute",
                                                                            left: 10,
                                                                            bottom: 8,
                                                                            textAlign: "center",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            cursor: "pointer"
                                                                        }}>{x.expanded ? "-" : "+"}</div>
                                                                    <table style={{ width: "100%", position: "relative", top: 5, borderCollapse: "separate", borderSpacing: "0 4px", }}>
                                                                        <tr style={{ fontSize: 16 }}>
                                                                            <th style={{ ...tableHeaderStyle, width: "20%" }} >MARKET FOCUS</th>
                                                                            <th style={{ ...tableHeaderStyle, width: "15%" }} >SIDE</th>
                                                                            <th style={{ ...tableHeaderStyle, width: "15%" }} >SIZE</th>
                                                                            <th style={{ ...tableHeaderStyle, width: "15%" }} >PRICE</th>
                                                                            <th style={{ ...tableHeaderStyle, width: "20%" }} >CREATED AT</th>
                                                                            <th style={{ ...tableHeaderStyle, width: "20%" }} >ACTION</th>
                                                                        </tr>
                                                                        {x.logs.slice().reverse().map(log =>
                                                                            <TableRowAccumulate log={log} x={x} disableAction={disableAction} setDisableAction={setDisableAction} setAccumulators={setAccumulators} botId={selectedBot.id} />
                                                                        )}
                                                                    </table>
                                                                </div>
                                                            </tr>

                                                            if (x.saved) {
                                                                return <>
                                                                    <tr>
                                                                        <td style={{ ...tableRowStyle, position: "relative" }}>
                                                                            {x.symbol || '-'}
                                                                            {(botState === 'play' && !x.paused) && <>
                                                                                <div style={{ height: x.expanded ? 158 : 80, width: 1, borderLeft: "2px dashed", left: 19, position: "absolute" }}></div>
                                                                                <div style={{ height: 1, width: 15, borderBottom: "2px dashed", position: "absolute", bottom: x.expanded ? -149 : -71, left: 23 }}></div>
                                                                            </>}

                                                                        </td>
                                                                        <td style={tableRowStyle} >{x.interval || '-'}</td>
                                                                        <td style={tableRowStyle} >
                                                                            <div style={{ display: "flex", flexDirection: "row", padding: 5, gap: 5 }}>
                                                                                {botState === 'play' && <span>
                                                                                    <Button
                                                                                        onClick={() => {
                                                                                            if (x.paused) {
                                                                                                setAccumulators(previousState => {
                                                                                                    let newAccumulators = [...previousState];
                                                                                                    let Index = newAccumulators.findIndex(accumulator => accumulator.id === x.id);
                                                                                                    if (Index !== -1) {
                                                                                                        newAccumulators[Index].paused = !newAccumulators[Index].paused;
                                                                                                    }
                                                                                                    return newAccumulators;
                                                                                                });
                                                                                                editAccumulators(x);
                                                                                            } else {
                                                                                                deleteAccumulators({ bot_id: x.bot_id, symbol: x.symbol, id: x.id, user_id: x.user_id })
                                                                                                setAccumulators(previousState => {
                                                                                                    let newAccumulators = [...previousState];
                                                                                                    let Index = newAccumulators.findIndex(accumulator => accumulator.id === x.id);
                                                                                                    if (Index !== -1) {
                                                                                                        newAccumulators[Index].paused = !newAccumulators[Index].paused;
                                                                                                        newAccumulators[Index].logs = [];
                                                                                                        newAccumulators[Index].expanded = false;
                                                                                                    }
                                                                                                    return newAccumulators;
                                                                                                })
                                                                                            }
                                                                                        }}
                                                                                        style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>{x.paused ? 'Play' : 'Pause'}</Button>
                                                                                </span>}


                                                                                <span><Button
                                                                                    onClick={() => {
                                                                                        message.destroy('cancel');
                                                                                        editAccumulator(x);
                                                                                    }}
                                                                                    style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>Edit</Button></span>
                                                                                <span>

                                                                                    <Popconfirm placement="left" title={'Are you sure to delete this accumulator strategy?'} onConfirm={() => {

                                                                                        let newAccumulators = accumulators.filter(accumulator => accumulator.id !== x.id);
                                                                                        setAccumulators(newAccumulators);
                                                                                        deleteAccumulators({ bot_id: x.bot_id, symbol: x.symbol, id: x.id, user_id: x.user_id })

                                                                                    }} okText="Yes" cancelText="No">
                                                                                        <Button style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}  >Delete</Button>
                                                                                    </Popconfirm>
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    {subTable}
                                                                </>


                                                            } else {
                                                                return <>
                                                                    <tr>
                                                                        <td style={tableRowEditStyle}>
                                                                            <Select
                                                                                showSearch
                                                                                placeholder="Symbol"
                                                                                value={accumulatorItem.symbol}
                                                                                style={{ color: "black", width: 200 }}
                                                                                onChange={(value) => {
                                                                                    setAccumulatorItem({
                                                                                        ...accumulatorItem,
                                                                                        symbol: value
                                                                                    })
                                                                                }}
                                                                            >
                                                                                {markets.map(market => <Option value={market.symbol}>{market.symbol}</Option>)}

                                                                            </Select>
                                                                        </td>

                                                                        <td style={tableRowEditStyle}>
                                                                            <Input
                                                                                value={accumulatorItem.interval}
                                                                                onChange={(e) => {
                                                                                    setAccumulatorItem({
                                                                                        ...accumulatorItem,
                                                                                        interval: e.target.value
                                                                                    })
                                                                                }}
                                                                                style={{ color: "black", width: 100 }} placeholder="Interval" />
                                                                        </td>

                                                                        <td style={tableRowEditStyle}>
                                                                            <div style={{ fontSize: 15, position: "relative" }}>
                                                                                <Button
                                                                                    disabled={disableAction}
                                                                                    style={{ backgroundColor: "#161616", color: "white", marginLeft: 4, borderRadius: 10 }}
                                                                                    onClick={() => {
                                                                                        addAccumulator(x?.id);
                                                                                    }}>Save</Button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    {subTable}
                                                                </>
                                                            }

                                                        })}
                                                        {provided.placeholder}
                                                    </tbody>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </table>
                                    }


                                    {selectedBot.type === 'marketmaker' && (newOrderCreate ?
                                        <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                                            <Button onClick={cancelCreateOrder} style={{ backgroundColor: "#161616", color: "white", width: 150, height: 50, marginTop: 10 }} type="default">CANCEL</Button>
                                        </div> :
                                        orders.filter(order => order?.bot_id === selectedBot.id).length == 0 ?
                                            <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                                                <img src={noStrategy} style={{ marginBottom: 10 }} />
                                                <div style={{ color: "white" }} >THERE ARE NO STRATEGIES HERE.</div>
                                                <div style={{ color: "white" }} >START BY NEW STRATEGY BELOW.</div>
                                                <Button onClick={createOrder} style={{ backgroundColor: "#161616", color: "white", width: 150, height: 50, marginTop: 10 }} type="default">NEW STRATEGY</Button>
                                            </div>
                                            :

                                            <div style={{ textAlign: "center", marginTop: 40, height: 100 }}>
                                                <Button onClick={createOrder} style={{ backgroundColor: "#161616", color: "white", width: 150, height: 50, marginTop: 10 }} type="default">NEW STRATEGY</Button>
                                            </div>)
                                    }

                                    {selectedBot.type === 'accumulator' && (newAccumulatorCreate ?
                                        <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                                            <Button onClick={cancelCreateAccumulator} style={{ backgroundColor: "#161616", color: "white", width: 150, height: 50, marginTop: 10 }} type="default">CANCEL</Button>
                                        </div>
                                        :
                                        <div style={{ textAlign: "center", marginTop: 40, height: 100 }}>
                                            <Button onClick={createAccumulator} style={{ backgroundColor: "#161616", color: "white", width: 250, height: 50, marginTop: 10 }} type="default">NEW ACCUMULATOR STRATEGY</Button>
                                        </div>
                                    )
                                    }


                                </div>

                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>

            }

        </>
    );
};

export default Advanced;